module.exports = __webpack_public_path__ + "img/hero-1.f866869c.png";